import Vue from 'vue';
import Vuex from 'vuex';
import { db } from '../main';


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    parkeados:[],
    autos:[],
    marcas:[],
    puestos:[],
    personas:[],

    
  },
  getters:{
    enviardataparkeados(state){
      return state.parkeados;
    },
    enviardataautos(state){
      return state.autos; 
    },
    enviardatamarcas(state){
      return state.marcas
    },
    enviardatapuestos(state){
      return state.puestos
    },
    enviardatapersonas(state){
      return state.personas
    }

  },
  mutations: {
    llamarparking(state){
      db.collection('parking').orderBy('numeropuesto').onSnapshot((datos)=>{
        let auxiliar=[];
        datos.forEach((element)=>{
          auxiliar.push({
            fechaing:element.data().fechaing.toDate(),
            fechasal:element.data().fechasal.toDate(),   
            nombre:element.data().nombre,
            patente:element.data().patente,
            numeropuesto:element.data().numeropuesto,
            numerodepartamento:element.data().numerodepartamento,
            aparcado:element.data().aparcado,
            idDoc:element.id
          })          
        });
        
        state.parkeados= auxiliar;
        console.log(state.parkeados);
      })
    },
    out(state,idDoc){
      //let fecha=new Date();
      //let mifecha = fecha.getDate() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getFullYear() + ' ' + fecha.getHours() + ':' + fecha.getMinutes();
      db.collection('parking').doc(idDoc).update({
        aparcado:false,
        fechasal: new Date(),
      })
    },
    llamarautos(state){
      db.collection('autos').orderBy('patente').onSnapshot((datos)=>{
        let auxiliar=[];
        datos.forEach((element)=>{
          auxiliar.push({
            patente:element.data().patente.toUpperCase(),
            residente:element.data().residente,
            numerodepartamento:element.data().numerodepartamento,
            nombre:element.data().nombre.toUpperCase(),
            marca:element.data().marca,
            idDoc:element.id
          })
        })
        state.autos = auxiliar; 
      })
    },
    saveCar(state, informacion){
      db.collection('autos').add({
        patente:informacion.patente,
        residente:informacion.residente,
        numerodepartamento:informacion.numerodepartamento,
        nombre:informacion.nombre,
        marca:informacion.marca
      })
    },
    saveParking(state, informacion){  
      console.log(informacion)         ;
      db.collection('parking').add({
        aparcado:informacion.aparcado,
        fechaing:informacion.fechaing,
        fechasal:informacion.fechasal,
        nombre:informacion.nombre,
        numeropuesto:informacion.numeropuesto,
        numerodepartamento:informacion.numerodepartamento,
        patente:informacion.patente,
        residente:informacion.residente,
      })
    },    
    llamarmarcas(state){
      db.collection('marcas').orderBy('nombremarca').onSnapshot((datos)=>{
        let auxiliar=[];
        datos.forEach((element)=>{
          auxiliar.push({
            nombremarca:element.data().nombremarca,
            url:element.data().url,
            idDoc: element.id
          })
        })
        state.marcas= auxiliar;
      })
    },
    llamarpuestos(state){
      db.collection('puestos').orderBy('value').onSnapshot((datos)=>{
        let auxiliar=[];
        datos.forEach((element)=>{
          auxiliar.push({
            text:element.data().text,
            value:element.data().value,
            disponible:element.data().disponible,
            idDoc: element.id
          })
        })
        state.puestos= auxiliar;
      })
    },
    puestoDisponibilidad(state, valor){      
      let registroseleccionado = state.puestos.find(dato=>(dato.text)===(valor.toString())) 
      //console.log(registroseleccionado.idDoc);
      //console.log(registroseleccionado.disponible);
      //console.log(!registroseleccionado.disponible);      
      db.collection('puestos').doc(registroseleccionado.idDoc).update({
        disponible:!registroseleccionado.disponible
      })
    },
    generapuesto(state,parametros){
      db.collection('puestos').add({
        text: parametros.text,
        value:parametros.value,
        disponible:parametros.disponible
      })
    },
    llamarpersonas(state){
      db.collection('personas').orderBy('nombre').onSnapshot((datos)=>{
        let auxiliar=[];
        datos.forEach((element) => {
          auxiliar.push({
            fecha: element.data().fecha.toString(),
            rut:element.data().rut,
            nombre:element.data().nombre,
            residente:element.data().residente,
            departamento:element.data().departamento,
            idDoc:element.id
          })
        })
        state.personas=auxiliar; 
      })
    },
    savePersona(state, parametrossavePersona){
      db.collection('personas').add({
        fecha: parametrossavePersona.fechaing,
        rut: parametrossavePersona.rut,
        nombre: parametrossavePersona.nombre,
        residente: parametrossavePersona.residente,      
        departamento: parametrossavePersona.numerodepartamento,
      })
    }
/*     llenarBDMarcas(state, nombre){
      db.collection('marcas').add({
        nombremarca:nombre
     })
    } */



  },
  actions: {
    llamarparking(context){
      context.commit('llamarparking')
    },
    out(context, idDoc){
      context.commit('out',idDoc); 
    },
    llamarautos(context){
      context.commit('llamarautos');
    },
    saveCar(context, parametrossaveCar){
      context.commit('saveCar', parametrossaveCar);
    },
    saveParking(context, parametrossaveParking){
      context.commit('saveParking', parametrossaveParking);
    },
    llamarmarcas(context){
      context.commit('llamarmarcas')
    },
    llamarpuestos(context){
      context.commit('llamarpuestos')
    },
    puestoDisponibilidad(context, parametro){      
      context.commit('puestoDisponibilidad', parametro)
    },
    generapuesto(context,parametros){
      context.commit('generapuesto', parametros)
    },
    llamarpersonas(context){
      context.commit('llamarpersonas')
    },
    savePersona(context, parametrossavePersona){
      context.commit('savePersona', parametrossavePersona);
    }
    /* llenarBDMarcas(context,nombre){
      context.commit('llenarBDMarcas', nombre);
    } */
  },
    modules: {
  }
})
